// Mock data for Uddhav Chaube Portfolio

export const profile = {
  name: "Uddhav Chaube",
  title: "Entrepreneur · Business Strategist · Startup Builder",
  tagline: "Building practical, scalable businesses across logistics, real estate, petroleum and hospitality.",
  email: "uddhav.chaube16@gmail.com",
  phone: "+91 8005202002",
  yearsExperience: "4\u20135",
  industries: 5,
  ventures: 4,
  acres: "100+",
  photo: "https://customer-assets.emergentagent.com/job_2b9f3caf-1e6b-4dae-82de-f81e641a6dd1/artifacts/jq3fza3q_Uddhav%20Chaube%20professional%20photo.JPG"
};

export const aboutParagraphs = [
  "A dynamic and forward-thinking entrepreneur with 4\u20135 years of hands-on experience across diverse industries, including real estate, petroleum, and food & beverage. Known for building practical, scalable businesses driven by innovation and operational excellence.",
  "With a strong execution mindset, I focus on identifying high-potential opportunities, optimizing operations, and creating sustainable revenue-driven models that deliver long-term value."
];

export const currentFocus = {
  title: "Cold Chain Logistics",
  subtitle: "Current Focus · Building Now",
  description: "Building a next-generation logistics solution focused on temperature-controlled transportation. The goal is to make it more efficient, reliable, and cost-effective for businesses.",
  objectives: [
    "Reduce logistics costs through operational efficiency",
    "Improve reliability in temperature-sensitive supply chains",
    "Build a scalable, tech-enabled logistics network"
  ]
};

export const directorships = [
  { name: "DSC Enterprises LLP", role: "Designated Partner" },
  { name: "Urbanzip Global Private Limited", role: "Director" },
  { name: "Budwar House Realty Private Limited", role: "Director" },
  { name: "Nagrik Today Mediavision Private Limited", role: "Director" }
];

export const verticals = [
  {
    id: "petroleum",
    title: "Petroleum",
    summary: "Operational and business experience in fuel and energy-related ventures, with a focus on efficiency, regulatory compliance, and sustainable growth.",
    image: "https://customer-assets.emergentagent.com/job_2b9f3caf-1e6b-4dae-82de-f81e641a6dd1/artifacts/9e2phe5a_IMG_0651.JPG",
    metric: "Operating Vertical",
    metricValue: "Jio-bp Outlet"
  },
  {
    id: "fnb",
    title: "Food & Beverage",
    summary: "Hands-on experience in building and scaling customer-focused F&B operations with a strong emphasis on quality, customer experience, and profitability.",
    image: "https://customer-assets.emergentagent.com/job_2b9f3caf-1e6b-4dae-82de-f81e641a6dd1/artifacts/3ol3vobi_Screenshot%202026-04-24%20at%203.14.37%E2%80%AFPM.png",
    metric: "Brand Association",
    metricValue: "Theka Coffee & Shakes"
  },
  {
    id: "hospitality",
    title: "Hospitality · Marriage Garden",
    summary: "Own and operate a premium marriage garden in Uttar Pradesh that caters to large-scale social and corporate events, with a focus on experience, efficient operations, and high utilization.",
    image: "https://customer-assets.emergentagent.com/job_2b9f3caf-1e6b-4dae-82de-f81e641a6dd1/artifacts/7tclccqx_SBFXNR-17.jpg",
    metric: "Asset Type",
    metricValue: "Marriage Garden"
  },
  {
    id: "real-estate",
    title: "Real Estate",
    summary: "Strategic investments and property management across event spaces and land assets, with a focus on long-term value creation, asset optimization, and consistent returns.",
    image: "https://customer-assets.emergentagent.com/job_uddhav-ventures/artifacts/rpng0g1w_Screenshot%202026-04-27%20at%201.28.31%E2%80%AFPM.png",
    metric: "Property Portfolio",
    metricValue: "Multi-asset"
  },
  {
    id: "agriculture",
    title: "Agriculture & Land Management",
    summary: "Active involvement in large-scale farming and land utilization across 100+ acres in Uttar Pradesh, with a focus on productivity, sustainability, and long-term asset value.",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80",
    metric: "Land Footprint",
    metricValue: "100+ Acres"
  }
];

export const strengths = [
  { title: "Business Strategy & Development", icon: "Target" },
  { title: "Operations & Execution Excellence", icon: "Settings" },
  { title: "Market Expansion & Growth Planning", icon: "TrendingUp" },
  { title: "Entrepreneurial Leadership", icon: "Compass" },
  { title: "Opportunity Identification & Scaling", icon: "Search" },
  { title: "Cost Optimization & Revenue Growth", icon: "LineChart" }
];

export const differentiators = [
  "Multi-industry experience with practical, ground-level exposure",
  "Strong execution capability with attention to detail",
  "Ability to scale businesses from ground level upwards",
  "Focus on profitability and long-term sustainability"
];

export const principles = [
  { title: "Data-driven decision making", desc: "Numbers over narratives. Every move is measured." },
  { title: "Execution over theory", desc: "Frameworks help, but only execution compounds." },
  { title: "Systems that scale", desc: "Building processes that outlive the founder." },
  { title: "Lean operations", desc: "Maximum efficiency, minimum waste." }
];

export const visionMission = {
  vision: "To build impactful businesses that transform essential industries, especially logistics, into more accessible, efficient, and scalable systems. To create ventures that not only generate profit but also solve real-world operational challenges.",
  mission: "To consistently identify gaps in traditional industries and build innovative, execution-focused solutions that deliver measurable value to customers and stakeholders."
};
